import React, { useState, useEffect } from 'react';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function InvitationBanner() {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user?.team_status === 'invited' && user?.organization_id) {
      api.get('/api/organization').then(res => setOrg(res.data.organization)).catch(() => {});
    }
  }, [user]);

  if (user?.team_status !== 'invited' || !user?.organization_id) return null;

  const handleAccept = async () => {
    setLoading(true);
    try {
      await api.post('/api/organization/accept-invitation');
      await refreshUser();
      navigate('/dashboard/team?tab=overview');
    } catch {}
    setLoading(false);
  };

  return (
    <div style={{ background: 'linear-gradient(135deg, #F59E0B, #D97706)', border: 'none', borderRadius: 12, padding: '14px 20px', marginBottom: 16, color: '#0F172A', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
      <div>
        <strong style={{ fontSize: 14 }}>You’ve been invited to join {org?.name || 'an organization'} as {(user?.team_role || 'SDR').toUpperCase()}</strong>
        <div style={{ fontSize: 12, opacity: 0.85, marginTop: 2 }}>Accept the invitation to access team features and your assigned workspace.</div>
      </div>
      <button onClick={handleAccept} disabled={loading} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#0F172A', color: '#F59E0B', cursor: 'pointer', fontSize: 12, fontWeight: 700 }}>
        {loading ? 'Accepting...' : 'Accept Invitation'}
      </button>
    </div>
  );
}
